import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingHyderabad from "../components/blogs/DigitalMarketingHyderabad";

const DigitalMarketingAgencyHyderabad = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Services in companies | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Get result-oriented digital marketing companies in Hyderabad with SMS ZOO ZOO. We help businesses increase traffic, leads, and conversions."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-hyderabad"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingHyderabad />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyHyderabad;
